enum PackageAdditionalServiceEnum {
  InspectPackage = 1,
  ExtraPhotos = 2,
  ReturnToSender = 3,
  AbandonPackage = 4,
}

export default PackageAdditionalServiceEnum
